
import { StyledHowItem, StyledHowItemTitle } from './HowItem.styled';

const HowItem = ({ howItemKey, howItemTitle, howItemText }) => (
  <StyledHowItem key={howItemKey}>
    <StyledHowItemTitle>{howItemTitle}</StyledHowItemTitle>
    <p>{howItemText}</p>
  </StyledHowItem>
);

export default HowItem;
